/**
 * @param {string} selector
 * @param listener
 */
export default (selector, listener) =>
  /**
   * @param {Event} event
   */
  (event) => {
    const target = event.target.closest(selector)
    if (!target || !event.currentTarget.contains(target)) {
      return
    }
    listener.call(target, event)
  }
